/** Нормализация id курса (API может отдавать number или string). */
export function normalizeCourseId(id) {
  if (id == null || id === '') return null;
  const n = Number(id);
  return Number.isFinite(n) ? n : null;
}

export function courseIdsEqual(a, b) {
  return normalizeCourseId(a) === normalizeCourseId(b);
}
